import { render, staticRenderFns } from "./TotalData.vue?vue&type=template&id=2e817fdf&"
import script from "./TotalData.vue?vue&type=script&lang=js&"
export * from "./TotalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports